import { Button, Title } from "dash-styled"
import { useDispatch } from "react-redux"
import { userLoginWithAzure } from "../../../../Actions/Auth/AuthActions"
import { isAuthenticated } from "../../../../Helpers/Functions/Selectors/auth"
import { useAppState } from "../../../../Hooks/useReduxState"
import { routePaths } from "../../../../Routes"
import { Redirect } from "react-router"
import { MainThunkDispatch } from "../../../../Reducers"
import { safePromise } from "../../../../Helpers/Functions/promise"

interface AzureOAuthProps {
    provider?: string
}

export default function AzureOAuth({ provider }: AzureOAuthProps) {
    const dispatch = useDispatch<MainThunkDispatch>()
    const authenticated = useAppState(isAuthenticated)

    if (!provider) return null

    const signIn = async () => {
        await safePromise(dispatch(userLoginWithAzure(provider)))
    }

    if (authenticated) {
        return <Redirect to={routePaths.dashboard()} />
    }

    return (
        <div>
            <Title
                component="h6"
                variant="heading5"
                weight="semibold"
                className="flex-shrink flex-grow-0"
                noMargin={true}
                testId="azure-oauth-title"
            >
                Welcome to {provider}
            </Title>
            <Button onClick={signIn} testId="azureLogin">
                Sign In
            </Button>
        </div>
    )
}
